/*
 *  I04CONVVOLENERCalcul.js
 *
 *  Created by Sébastien Hecart on 2018-03-10 18:44:53 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

//TODO CASE import {} from "@batical/data/src/Queries/BatiQueries";

import { I04CONVVOLENER_State } from '@batical/types/src'
//TODO IF REQUIREDimport {} from '@batical/types/src';
function I04CONVVOLENER_docalcul(state: I04CONVVOLENER_State) {
  state.res_energie = state.in_pci * state.in_volume
  state.invalidated = false
  return state
}

export default I04CONVVOLENER_docalcul
